import { Badge } from '@/components/ui/badge';
import { kindLabel } from '@/lib/campaignKind';
import type { CampaignKind } from '@/types/dataset';

interface CampaignKindBadgeProps {
  kind?: CampaignKind;
}

export function CampaignKindBadge({ kind }: CampaignKindBadgeProps) {
  return (
    <Badge
      variant={kind === 'telegram_outreach' ? 'processing' : 'secondary'}
      data-testid="campaign-kind-badge"
    >
      {kindLabel(kind)}
    </Badge>
  );
}
